import React from 'react';

/**
 * 기능 캡처 이미지 컴포넌트.
 * 1차: SVG 플레이스홀더 (src/images/intro/{file})
 * 2차: 디자이너 PNG 동일 파일명으로 덮어쓰기 — 코드 변경 0
 *
 * onError 시 _placeholder.svg 로 graceful fallback (이미지 누락에도 빌드 안전)
 */
const Screenshot = ({ file, alt }) => {
    const baseUrl = process.env.PUBLIC_URL || '';
    const src = `${baseUrl}/intro-screenshots/${file}`;
    const fallback = `${baseUrl}/intro-screenshots/_placeholder.svg`;

    const handleError = (e) => {
        if (e.target.src.indexOf('_placeholder.svg') === -1) {
            e.target.src = fallback;
        }
    };

    return (
        <div className="intro-screenshot">
            <img src={src} alt={alt || ''} onError={handleError} loading="lazy" />
        </div>
    );
};

export default Screenshot;
